import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202508: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202508",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-08-01",
  endDate: "2025-08-31",
  impressions: 5952,
  clicks: 92,
  adsSpendDollars: 180,
  budgetDollars: 600,
  salesDollars: 1264,
  bestEstimateRoas: 7.02,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.3,
  reorderConversions: 5,
  dataAvailableAtDate: "2025-09-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
